"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SummaryTable = function SummaryTable(props) {
  var columns = [{
    name: 'fields.participantId',
    label: 'Participant List',
    sort: true
  }, {
    name: 'teenDataPre.devTags.YouthPreScore',
    label: 'Teen Pre',
    className: 'text-center'
  }, {
    name: 'teenDataPost.devTags.YouthPostScore',
    label: 'Teen Post',
    className: 'text-center'
  }, {
    name: 'caregiverDataPre.devTags.CaregiverPreScore',
    label: 'Caregiver Pre',
    className: 'text-center'
  }, {
    name: 'caregiverDataPost.devTags.CaregiverPostScore',
    label: 'Caregiver Post',
    className: 'text-center'
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    rowKey: "pawn.pawnId",
    graphqlVariables: {
      groupIds: props.filters.groupIds,
      startDate: props.filters.startDate,
      endDate: props.filters.endDate
    },
    query: props.query,
    columns: columns
    // render={tableProps => console.log(tableProps)}
  });
};
var _default = exports["default"] = SummaryTable;